import {
  init_shim
} from "./chunk-XJTZ422K.js";

// node_modules/phaser3-rex-plugins/plugins/utils/math/angle/angletodirections/Const.js
init_shim();
var Const_default = {
  "up&down": 0,
  "left&right": 1,
  "4dir": 2,
  "8dir": 3
};

// node_modules/phaser3-rex-plugins/plugins/utils/math/angle/angletodirections/AngleToDirections.js
init_shim();
var AngleToDirections = function(angle, dirMode, out) {
  if (out === void 0) {
    out = {};
  } else if (out === true) {
    out = globOut;
  }
  out.left = false;
  out.right = false;
  out.up = false;
  out.down = false;
  angle = (angle + 360) % 360;
  switch (dirMode) {
    case 0:
      if (angle < 180) {
        out.down = true;
      } else {
        out.up = true;
      }
      break;
    case 1:
      if (angle > 90 && angle <= 270) {
        out.left = true;
      } else {
        out.right = true;
      }
      break;
    case 2:
      if (angle > 45 && angle <= 135) {
        out.down = true;
      } else if (angle > 135 && angle <= 225) {
        out.left = true;
      } else if (angle > 225 && angle <= 315) {
        out.up = true;
      } else {
        out.right = true;
      }
      break;
    case 3:
      if (angle > 22.5 && angle <= 67.5) {
        out.down = true;
        out.right = true;
      } else if (angle > 67.5 && angle <= 112.5) {
        out.down = true;
      } else if (angle > 112.5 && angle <= 157.5) {
        out.down = true;
        out.left = true;
      } else if (angle > 157.5 && angle <= 202.5) {
        out.left = true;
      } else if (angle > 202.5 && angle <= 247.5) {
        out.left = true;
        out.up = true;
      } else if (angle > 247.5 && angle <= 292.5) {
        out.up = true;
      } else if (angle > 292.5 && angle <= 337.5) {
        out.up = true;
        out.right = true;
      } else {
        out.right = true;
      }
      break;
  }
  return out;
};
var globOut = {};
var AngleToDirections_default = AngleToDirections;

// node_modules/phaser3-rex-plugins/plugins/utils/position/ScreenXYToWorldXY.js
init_shim();
var ScreenXYToWorldXY = function(screenX, screenY, camera, out) {
  if (out === void 0) {
    out = {};
  } else if (out === true) {
    out = globalOut;
  }
  camera.getWorldPoint(screenX, screenY, out);
  return out;
};
var globalOut = {};
var ScreenXYToWorldXY_default = ScreenXYToWorldXY;

export {
  Const_default,
  AngleToDirections_default,
  ScreenXYToWorldXY_default
};
